




































import BuyNowButton from './BuyNowButton';
import { hideDiscounts } from '../../../../../../frontend/helper/formula';

export default BuyNowButton.extend({
  name: 'RestaurantsBuyNowButton',
  computed: {
    buttonText() {
      if (!this.isForSale) {
        return (this as any).$t('18963.App_restaurantDetailsBookButtonSoldOut');
      }
      return this.text;
    },
    showOriginalPrice(): boolean {
      return !!this.pricing?.hasOriginal?.() && !hideDiscounts();
    },
    summaryIcon() {
      if (this.summary === (this as any).$t('6021.PartnerApi_AvailabilityStatus_warning')) {
        return 'tr-clock';
      }
      return 'tr-calendar';
    },
  },
  methods: {
    openPriceModal(event: Event, price: string) {
      (window as any).priceInformationModal(event, price);
    },
  },
});
